var $22573d5058bf9ea8$exports = {};
$22573d5058bf9ea8$exports = {
    "Clear search": `Aramay\u{131} temizle`
};


export {$22573d5058bf9ea8$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
